"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitModal = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var react_feather_1 = require("react-feather");
var BaseModal_1 = require("./BaseModal");
var Text_1 = require("./Text");
var theme_1 = require("./theme");
var modalSizes = {
    small: "512px",
    medium: "608px",
};
var getWidthStyles = function (width) {
    if (!width)
        return undefined;
    if (width in modalSizes) {
        return {
            width: "100%",
            maxWidth: modalSizes[width],
        };
    }
    else {
        return {
            width: "100%",
            maxWidth: width,
        };
    }
};
/**
 * Main Modal component.
 * @param {Function} hideModal - Required. Function that will run on modal exit
 * @param {boolean} isOpen - Required. Describes if the modal should be shown or not
 * @param {string=} title - Title of the modal
 * @param {string=} info - Additional text below the title
 * @param {string=} width - Can be small, medium, or a custom pixel value
 * @param {Object=} style - Custom style object used in react-modal
 * @param {Object=} style.content - Custom content styles
 * @param {Object=} style.overlay - Custom overlay styles
 * @param {boolean=} shouldCloseOnOverlayClick - Controls whether the overlay should close the modal
 */
var SplitModal = function (_a) {
    var isOpen = _a.isOpen, hideModal = _a.hideModal, title = _a.title, info = _a.info, width = _a.width, children = _a.children, _b = _a.style, style = _b === void 0 ? {} : _b, shouldCloseOnOverlayClick = _a.shouldCloseOnOverlayClick;
    var widthStyles = getWidthStyles(width);
    return (react_1.default.createElement(BaseModal_1.BaseModal, { isOpen: isOpen, hideModal: hideModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, style: __assign(__assign({}, style), { overlay: __assign({ display: "flex", justifyContent: "center", boxSizing: "border-box", backgroundColor: theme_1.theme.colors.black4, zIndex: 2 }, style.overlay), content: __assign(__assign({ position: "relative", borderRadius: "8px", border: 0, inset: 0, boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.12)", padding: 0, margin: "auto 16px", boxSizing: "border-box" }, widthStyles), style.content) }) },
        react_1.default.createElement(GrayBackground, null,
            react_1.default.createElement(FlexRow, null,
                react_1.default.createElement(Text_1.Text, { variant: "headlineSmall" }, title),
                react_1.default.createElement(CloseIcon, { size: 18, stroke: theme_1.theme.colors.gray600, onClick: hideModal })),
            info && (react_1.default.createElement(Text_1.Text, { variant: "paragraphLarge", pt: "medium" }, info))),
        react_1.default.createElement(WhiteBackground, null, children)));
};
exports.SplitModal = SplitModal;
var FlexRow = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var CloseIcon = (0, styled_1.default)(react_feather_1.X)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  flex-shrink: 0;\n  margin-left: auto;\n  margin-top: ", ";\n"], ["\n  cursor: pointer;\n  flex-shrink: 0;\n  margin-left: auto;\n  margin-top: ", ";\n"])), theme_1.theme.space.xxsmall);
var WhiteBackground = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: ", ";\n  padding: ", " ", ";\n"], ["\n  background: ", ";\n  padding: ", " ", ";\n"])), theme_1.theme.colors.white, theme_1.theme.space.medium, theme_1.theme.space.large);
var GrayBackground = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background: ", ";\n  padding: ", " ", ";\n"], ["\n  background: ", ";\n  padding: ", " ", ";\n"])), theme_1.theme.colors.gray100, theme_1.theme.space.medium, theme_1.theme.space.large);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
